/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { LoginOrigin } from '@/data/types/GTM';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const LoginOriginContext = createContext<LoginOrigin>('login_page');

export const LoginOriginProvider: FC<PropsWithChildren<{ origin: LoginOrigin }>> = ({
	origin,
	children,
}) => <LoginOriginContext.Provider value={origin}>{children}</LoginOriginContext.Provider>;

export const useLoginOrigin = () => useContext(LoginOriginContext);
